import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceReviewForm from './ServiceReviewForm'
import { storeServiceReview } from '../services'

import { handleError } from '../../../helpers'

export default function NewServiceReviewModal({ visible, onClose, service }) {
	const [loading, setLoading] = useState(false)
	const history = useHistory()
	const { register, handleSubmit, formState: { errors }, setValue } = useForm({
		defaultValues: {
			service_id: service.id,
			review_format_id: service.service_format.review_format_id
		}
	})

	const onSubmit = values => {
		setLoading(true)
		storeServiceReview(values)	
			.then(res => {
				message.success(res.data.message)
				history.push(`/service_reviews/${res.data.data.id}`)
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Crear Diagnóstico de Servicio</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<ServiceReviewForm 
						register={register}
						errors={errors}
						setValue={setValue}
					/>
					<Button color="primary" type="submit" disabled={loading}>
						{ loading && <Spinner animation='border' size="sm" /> }
						Crear Diagnóstico de Servicio
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}